
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7b47752c&scoped=true!../css/modalListarGlosa.css")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalListarGlosas.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7b47752c!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalListarGlosas.vue"),
  /* scopeId */
  "data-v-7b47752c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/glosa/modal/ModalListarGlosas.vue
// module id = 890
// module chunks = 1